import http from './http'

export default {
    create : function(user){
        user["inserir-usuario-teste"] = true;
        return http.post('./includes/php/ajax_insert.php', {
            data: user
        })
    },
    resend : function(_email){
        return http.post('./includes/php/ajax_insert.php', {
            data: {
                email : _email,
                "reenviar-email-teste" : true
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/js/services/test.js